import { AppProvider } from "contexts/AppContext";
import { createRoot } from 'react-dom/client';
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./utils/auth";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./styles/index.scss";
import ErrorPage from "./pages/Error";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

const debugMode = `${import.meta.env.REACT_APP_DEBUG}`.toLowerCase() === "true";

// Stocker les méthodes originales
const originalLog = console.log;
const originalError = console.error;
const originalInfo = console.info;
const originalWarn = console.warn;

// Fonction pour formater la date en chaîne lisible
function getFormattedDate() {
  return new Date().toISOString();
}

// console.log et console.info : uniquement en mode debug
console.log = (...args) => {
  if (debugMode) {
    originalLog(`[${getFormattedDate()}]`, ...args);
  }
};

console.info = (...args) => {
  if (debugMode) {
    originalInfo(`[${getFormattedDate()}]`, ...args);
  }
};

// console.error et console.warn : TOUJOURS actifs (ne jamais silencer les erreurs)
console.error = (...args) => {
  originalError(`[${getFormattedDate()}]`, ...args);
};

console.warn = (...args) => {
  originalWarn(`[${getFormattedDate()}]`, ...args);
};

const msalInstance = new PublicClientApplication(msalConfig);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/login",
    element: <App isLoginPage />,
  },
  {
    path: "/logout",
    element: <App isLogoutPage />,
  },
  {
    path: "*",
    element: <ErrorPage message="Page non trouvée" />,
  },
]);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ErrorBoundary>
    <AppProvider>
      <MsalProvider instance={msalInstance}>
        <RouterProvider router={router} />
      </MsalProvider>
    </AppProvider>
  </ErrorBoundary>
);
